import { createSlice } from "@reduxjs/toolkit";

export interface ConfigurationState {
    data: string
}

const initialState: ConfigurationState = {
    data: ''
}

const ConfigurationSlice = createSlice({
    name: 'configuration',
    initialState,
    reducers: {
        setApiUrl(state: ConfigurationState, action: any) {
            state.data = action.payload.apiUrl
        }
    }
});

export const ConfigurationActions = ConfigurationSlice.actions;

export default ConfigurationSlice;